// import { Link } from "react-router-dom";
// import PageBanner from "./PageBanner";
// import SectionHeader from "./SectionHeader";
// import React from "react";
// import SocialMediaSidebar from "./SocialMediaSidebar";

// const PrivacyPolicy = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Privacy Policy"
//         breadcrumb={[{ label: "Privacy Policy", href: "/" }]}
//       />

//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Privacy Policy @ AJEEVI"
//           shareUrl="https://your-site.com/privacy-policy"
//         />
//       </div>

//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Header Section */}
//           <div className="mb-10">
//             <h1 className="text-3xl font-bold text-black mb-2">
//               Privacy Policy
//             </h1>
//             <p className="text-lg text-black mb-4">
//               <strong>Effective Date:</strong> 17-06-2025
//               <br />
//               <strong>Platform Name:</strong> ParkAJV
//               <br />
//               <strong>Operated by:</strong> Ajeevi Technologies Pvt. Ltd.
//               <br />
//               <strong>Location:</strong> Noida, Uttar Pradesh, India
//             </p>
//           </div>

//           {/* Introduction Section */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               1. Introduction
//             </h4>
//             <p className="text-black mb-4 text-lg">
//               Ajeevi Technologies Pvt. Ltd. ("Ajeevi", "we", "us", or "our")
//               values your trust in our AI-driven parking solutions. This Privacy
//               Policy outlines how we collect, process, and protect your data
//               when you use **ParkAJV**, our smart parking management platform
//               for **Multi-Level Car Parks (MLCP), on-street, and off-street
//               parking**.
//             </p>
//             <p className="text-black text-lg">
//               ParkAJV leverages **IoT sensors, license plate recognition (LPR),
//               and dynamic pricing algorithms** to optimize parking efficiency.
//               We comply with the **Digital Personal Data Protection Act, 2023**,
//               ensuring your data is handled securely and transparently.
//             </p>
//             <p className="text-black text-lg mt-4">
//               By using ParkAJV, you consent to this Privacy Policy.
//             </p>
//           </div>

//           {/* Scope of Application */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               2. Scope of Application
//             </h4>
//             <p className="text-black mb-4 text-lg">
//               This policy applies to all ParkAJV services, including:
//             </p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>Mobile/Web Apps for drivers and parking operators</li>
//               <li>IoT-enabled parking sensors and LPR cameras</li>
//               <li>APIs integrated with municipal parking systems</li>
//               <li>Payment gateways and booking platforms</li>
//             </ul>
//             <p className="text-black text-lg">
//               It covers **all users**: drivers, parking operators, municipal
//               staff, and contractors.
//             </p>
//           </div>

//           {/* Types of Information We Collect */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               3. Types of Information We Collect
//             </h4>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               3.1 Personal Data
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>
//                 <strong>Driver Data:</strong> Mobile number (for OTP login),
//                 vehicle number plate, payment details.
//               </li>
//               <li>
//                 <strong>Operator Data:</strong> Business credentials, tax IDs,
//                 and bank details (for revenue sharing).
//               </li>
//             </ul>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               3.2 Parking Transaction Data
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>Entry/exit timestamps and duration</li>
//               <li>Parking slot location (zone/floor/spot number)</li>
//               <li>Payment amount and method (UPI/card/cash)</li>
//             </ul>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               3.3 Technical & Device Data
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>GPS location (for on-street parking navigation)</li>
//               <li>Device IP, OS, and browser type</li>
//               <li>LPR camera logs (for automated check-in/out)</li>
//             </ul>
//           </div>

//           {/* How We Use Your Data */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               4. How We Use Your Data
//             </h4>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               4.1 Core Parking Services
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>Automated slot allocation and dynamic pricing</li>
//               <li>Real-time parking availability updates</li>
//               <li>Fraud prevention (e.g., duplicate bookings)</li>
//             </ul>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               4.2 Analytics & Optimization
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//               <li>Peak-hour demand prediction</li>
//               <li>Route optimization for parking attendants</li>
//               <li>Revenue reports for operators</li>
//             </ul>

//             <h5 className="text-xl font-semibold mb-3 text-black">
//               4.3 Compliance & Security
//             </h5>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>Audit trails for dispute resolution</li>
//               <li>Detection of unauthorized access</li>
//             </ul>
//           </div>

//           {/* Data Sharing */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               5. Data Sharing
//             </h4>
//             <p className="text-black mb-4 text-lg">
//               We share data **only** with:
//             </p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>
//                 <strong>Municipal Authorities:</strong> For parking regulation
//                 enforcement.
//               </li>
//               <li>
//                 <strong>Payment Processors:</strong> Razorpay/UPI gateways
//                 (transaction data only).
//               </li>
//               <li>
//                 <strong>Law Enforcement:</strong> If required by court order.
//               </li>
//             </ul>
//           </div>

//           {/* Security Measures */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               6. Security Measures
//             </h4>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>End-to-end encryption for payment data</li>
//               <li>Anonymized LPR logs after 30 days</li>
//               <li>Regular penetration testing</li>
//             </ul>
//           </div>

//           {/* User Rights */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               7. Your Rights
//             </h4>
//             <p className="text-black mb-4 text-lg">You can:</p>
//             <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//               <li>Request access to your parking history</li>
//               <li>
//                 Delete your account (except transaction records for legal
//                 compliance)
//               </li>
//               <li>Opt out of promotional emails</li>
//             </ul>
//             <p className="text-black text-lg mt-4">
//               Contact{" "}
//               <a
//                 href="mailto:parking-support@ajeevi.com"
//                 className="text-[#00D084] hover:underline"
//               >
//                 parking-support@ajeevi.com
//               </a>{" "}
//               to exercise these rights.
//             </p>
//           </div>

//           {/* Contact */}
//           <div>
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               8. Contact Us
//             </h4>
//             <p className="text-black text-lg">
//               <strong>Ajeevi Technologies Pvt. Ltd.</strong>
//               <br />
//               Noida, Uttar Pradesh – 201301
//               <br />
//               📧{" "}
//               <a
//                 href="mailto:parking-support@ajeevi.com"
//                 className="text-[#00D084] hover:underline"
//               >
//                 parking-support@ajeevi.com
//               </a>
//               <br />
//               🌐{" "}
//               <a
//                 href="https://parkajv.ajeevi.in"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-[#00D084] hover:underline"
//               >
//                 parkajv.ajeevi.in
//               </a>
//             </p>
//             <p>Note: Privacy Policy is subjected to changed anytime.</p>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PrivacyPolicy;

import { Link } from "react-router-dom";
import PageBanner from "./PageBanner";
import SectionHeader from "./SectionHeader";
import React from "react";
import SocialMediaSidebar from "./SocialMediaSidebar";

const PrivacyPolicy = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Privacy Policy"
        breadcrumb={[{ label: "Privacy Policy", href: "/" }]}
      />

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Privacy Policy @ AJEEVI"
          shareUrl="https://your-site.com/privacy-policy"
        />
      </div>

     <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* Header Section */}
    <div className="mb-10">
      <h1 className="text-3xl font-bold text-black mb-2">
        Privacy Policy
      </h1>
      <p className="text-lg text-black mb-4">
        <strong>Effective Date:</strong> 17-06-2025
        <br />
        <strong>Platform Name:</strong> Smart Pole
        <br />
        <strong>Operated by:</strong> Ajeevi Technologies Pvt. Ltd.
        <br />
        <strong>Location:</strong> Noida, Uttar Pradesh, India
      </p>
    </div>

    {/* Introduction Section */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        1. Introduction
      </h4>
      <p className="text-black mb-4 text-lg">
        Ajeevi Technologies Pvt. Ltd. ("Ajeevi", "we", "us", or "our") values your trust in our IoT-enabled smart pole solutions. This Privacy Policy outlines how we collect, process, and protect your data when you interact with **Smart Pole**, our integrated platform for **smart lighting, environmental monitoring, public Wi-Fi, and surveillance**.
      </p>
      <p className="text-black text-lg">
        Smart Pole leverages **IoT sensors, cameras, and AI analytics** to enhance urban infrastructure. We comply with the **Digital Personal Data Protection Act, 2023**, ensuring your data is handled securely and transparently.
      </p>
      <p className="text-black text-lg mt-4">
        By using Smart Pole services, you consent to this Privacy Policy.
      </p>
    </div>

    {/* Scope of Application */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        2. Scope of Application
      </h4>
      <p className="text-black mb-4 text-lg">
        This policy applies to all Smart Pole services, including:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Smart lighting and energy management systems</li>
        <li>Environmental sensors (air quality, noise, weather)</li>
        <li>Public Wi-Fi hotspots</li>
        <li>Surveillance cameras with AI analytics</li>
        <li>Mobile/Web Apps for administrators and municipal staff</li>
      </ul>
      <p className="text-black text-lg">
        It covers **all users**: citizens, municipal authorities, and third-party service providers.
      </p>
    </div>

    {/* Types of Information We Collect */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        3. Types of Information We Collect
      </h4>

      <h5 className="text-xl font-semibold mb-3 text-black">
        3.1 Personal Data
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>
          <strong>User Data:</strong> Mobile number (for Wi-Fi authentication), device MAC address.
        </li>
        <li>
          <strong>Administrator Data:</strong> Government IDs, contact details (for authorized personnel).
        </li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">
        3.2 Environmental & Operational Data
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Air quality (PM2.5, CO2 levels)</li>
        <li>No pollution and decibel levels</li>
        <li>Energy consumption metrics</li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">
        3.3 Technical & Device Data
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>GPS location of smart poles</li>
        <li>Camera footage (anonymized for crowd analytics)</li>
        <li>Wi-Fi connection logs (duration, bandwidth usage)</li>
      </ul>
    </div>

    {/* How We Use Your Data */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        4. How We Use Your Data
      </h4>

      <h5 className="text-xl font-semibold mb-3 text-black">
        4.1 Core Smart Pole Services
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Dynamic lighting adjustment based on foot traffic</li>
        <li>Real-time environmental monitoring</li>
        <li>Public Wi-Fi bandwidth management</li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">
        4.2 Analytics & Urban Planning
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        <li>Traffic flow analysis (via anonymized camera data)</li>
        <li>Pollution heatmaps for city planners</li>
        <li>Energy optimization reports</li>
      </ul>

      <h5 className="text-xl font-semibold mb-3 text-black">
        4.3 Compliance & Security
      </h5>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>Incident detection (e.g., accidents, emergencies)</li>
        <li>Cybersecurity threat prevention</li>
      </ul>
    </div>

    {/* Data Sharing */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        5. Data Sharing
      </h4>
      <p className="text-black mb-4 text-lg">
        We share data **only** with:
      </p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>
          <strong>Municipal Authorities:</strong> For urban planning and emergency response.
        </li>
        <li>
          <strong>Research Institutions:</strong> Aggregated environmental data for studies.
        </li>
        <li>
          <strong>Law Enforcement:</strong> Camera footage only with valid court orders.
        </li>
      </ul>
    </div>

    {/* Security Measures */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        6. Security Measures
      </h4>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>End-to-end encryption for Wi-Fi authentication</li>
        <li>Automated blurring of faces in public camera feeds</li>
        <li>Regular firmware updates for IoT devices</li>
      </ul>
    </div>

    {/* User Rights */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        7. Your Rights
      </h4>
      <p className="text-black mb-4 text-lg">You can:</p>
      <ul className="list-disc pl-6 space-y-2 text-lg text-black">
        <li>Request deletion of Wi-Fi usage logs</li>
        <li>Opt out of non-essential data collection (where applicable)</li>
        <li>Access incident reports involving your data</li>
      </ul>
      <p className="text-black text-lg mt-4">
        Contact{" "}
        <a
          href="mailto:smartpole-support@ajeevi.com"
          className="text-[#00D084] hover:underline"
        >
         📧 smartpole-support@ajeevi.com
        </a>{" "}
        to exercise these rights.
      </p>
    </div>

    {/* Contact */}
    <div>
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        8. Contact Us
      </h4>
      <p className="text-black text-lg">
        <strong>Ajeevi Technologies Pvt. Ltd.</strong>
        <br />
        Noida, Uttar Pradesh – 201301
        <br />
        📧{" "}
        <a
          href="mailto:smartpole-support@ajeevi.com"
          className="text-[#00D084] hover:underline"
        >
          smartpole-support@ajeevi.com
        </a>
        <br />
        🌐{" "}
        <a
          href="https://smartpole.ajeevi.in"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#00D084] hover:underline"
        >
          smartpole.ajeevi.in
        </a>
      </p>
      <p>Note: Privacy Policy is subject to change without prior notice.</p>
    </div>
  </div>
</div>
    </>
  );
};

export default PrivacyPolicy;

